module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('styled-table', _vm._b({
    ref: "table"
  }, 'styled-table', _vm.tableProps, false), [_c('template', {
    slot: "tableHeader"
  }, [_vm._t("tableHeader")], 2), _vm._v(" "), _c('template', {
    slot: "loading"
  }, [_c('loader-dots', {
    staticClass: "emptyTableLayout__loader"
  })], 1), _vm._v(" "), _vm._t("default"), _vm._v(" "), _c('template', {
    slot: "empty"
  }, [(_vm.loading) ? [(_vm.loading) ? _c('loader-dots', {
    staticClass: "emptyTableLayout__loader"
  }) : _vm._e()] : [_c('empty-table', _vm._b({}, 'empty-table', _vm.emptyTableProps, false), [_vm._t("emptyTableSlot")], 2)]], 2)], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-35d714aa"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/components/common/tables/components/StyledEmptyTableLayout.vue
// module id = 1863
// module chunks = 0